<template lang="pug">
.marketing-leader-audit(v-loading="loading")
  title-bar
    span {{ $t('项目信息') }}
  div(style="margin-left: 20px")
    campaign-info(:data="data")
  title-bar
    span {{ $t('SOW') }}
  .sow-info(style="margin-left: 20px")
    el-row
      el-col(:span="4") {{ $t('SOW名称') }}
      el-col(:span="10") {{ data.sub_final_scope.sub_final_scope_name }}
    el-row
      el-col(:span="4") {{ $t('附件') }}
      el-col(:span="10")
        a(
          :href="data.sub_final_scope.spotplan_download_path"
          target="_blank"
        ) {{ data.sub_final_scope.spotplan_name }}
    category(:data="data.sub_final_scope.sub_final_scope_category")
    el-row
      el-col(:span="4") {{ $t('供应商') }}
      el-col(:span="10") {{ $t(data.sub_final_scope.sub_final_scope_vendor.vendor_name_ch) }}
  title-bar
    span {{ $t('供应商方案报价') }}
  .quotation-info(
    style="margin-bottom: 30px;margin-left: 20px"
  )
    el-row
      el-col(:span="4") {{ $t('方案') }}
      el-col(:span="20")
        a(
          :href="project.project_download_path"
        ) {{ project.project_name }}
    el-button(
      @click="visible = true"
      style="margin-bottom: 20px"
    ) {{ $t('查看报价明细') }}
    quotation-overview(
      :data="quotationOverviewArr"
    )
    quotation-dialog(
      v-if="quotationDetail.length > 0"
      :visible="visible"
      :data="quotationDetail"
      :viewMode="true"
      :hasRebate="false"
      :hasKol="false"
      @close="visible = false"
    )
  title-bar
    span {{ $t('项目审核') }}
  div(style="margin-left:20px")
    marketing-audit(:auditData="auditData" ref="audit")
  el-row(
    v-if="!isView"
    style="margin-left: 20px"
  )
    el-col(
      :span="20"
      :offset="4"
    )
      footer-button(
        @confirm="submit"
        @cancel="cancel"
      )
  audit-versions(
    :id="campaignId"
    :auditType="30"
    :businessType="businessType"
  )
</template>
<script>
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import MarketingAudit from '@/components/MarketingAudit'
import CampaignInfo from './CampaignInfo'
import axios from 'axios'
import AuditVersions from '@/components/AuditVersions'
import Category from '@/components/Category'
import QuotationDialog, { normalizeQuotation } from '@/components/QuotationDialog'
import QuotationOverview from '@/components/QuotationOverview'

export default {
  components: {
    TitleBar,
    FooterButton,
    MarketingAudit,
    CampaignInfo,
    AuditVersions,
    Category,
    QuotationOverview,
    QuotationDialog
  },
  data () {
    return {
      loading: false,
      campaignId: this.$store.state.campaign.id,
      data: {
        campaign: {},
        sub_final_scope: {}
      },
      auditData: {
        result: 1,
        remark: ''
      },
      quotationOverviewArr: [],
      quotationDetail: [],
      visible: false,
      project: {}
    }
  },
  mounted () {
    this.getCampaignInfo()
    if (this.isView) {
      this.getApproveResult()
    }
  },
  computed: {
    businessType () {
      return this.$store.state.campaign.businessType
    },
    subFinalScopeId () {
      return this.$store.state.campaign.sub_final_scope_id
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    }
  },
  methods: {
    getCampaignInfo () {
      axios
        .get('/common/getBusinessLog', {
          params: {
            servlet_path: '/campaign/new-campaign-and-brief-v3',
            business_key: this.campaignId
          }
        })
        .then((res) => {
          this.data = res
          this.$store.commit('campaign/setSubFinalScopeId', this.data.sub_final_scope.sub_final_scope_vendor.sub_final_scope_vendor_id)
          this.getVendorQuotation()
        })
    },
    getVendorQuotation () {
      axios.get('/management/subfinal/getVendorQuotation', {
        params: {
          sub_final_scope_vendor_id: this.data.sub_final_scope.sub_final_scope_vendor.sub_final_scope_vendor_id,
          phase_current: 2,
          phase_reality: this.phaseType
        }
      })
        .then(res => {
          this.quotationOverviewArr = res.price_overview
          this.quotationDetail = res.vendor_price.map(item => normalizeQuotation(item))
          this.project = res.project_path
        })
    },
    async submit () {
      const validateResult = await this.$refs.audit.$validator.validate()
      if (!validateResult) return
      this.loading = true
      const params = {
        campaign_id: this.$store.state.campaign.id,
        approve_result: this.auditData.result,
        remark: this.auditData.remark,
        task_id: this.$store.state.campaign.taskId
      }
      axios.get('/management/bypassCampaign/approveForLv4', {
        params: params
      })
        .then(() => {
          this.loading = false
          this.$store.commit('campaign/setIsBypassCampaign', true)
          this.$router.push('/campaign/process')
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel () {
      this.$router.push('/campaign/process')
    },
    getApproveResult () {
      axios
        .get('/management/subfinal/getApproveResult', {
          params: {
            id: this.campaignId,
            audit_type: 30,
            business_type: this.businessType
          }
        })
        .then(res => {
          this.auditData.result = res.status
          this.auditData.remark = res.comment
        })
    }
  }
}
</script>
